import { FC } from "react";

import { TimeIcon } from "@repo/edtech-assets";
import { formatToHHMMSS } from "@repo/edtech-video-player-utils";
import clsx from "clsx";

import st from "./Timer.module.scss";

const HALF_TIME_THRESHOLD_SECONDS = 30 * 60;

type Props = {
  time: number,
};

export const Timer: FC<Props> = ({ time }) => {
  return(
    <div
      className={
        clsx(
          st.timer, time <= HALF_TIME_THRESHOLD_SECONDS && st.half, time === 0 && st.over,
        )
      }
    >
      <TimeIcon />
      <span>{formatToHHMMSS(time)}</span>
    </div>
  );
};
